import { render, staticRenderFns } from "./EditDigiBoardContent.vue?vue&type=template&id=6603dbd0&scoped=true"
import script from "./EditDigiBoardContent.vue?vue&type=script&lang=js"
export * from "./EditDigiBoardContent.vue?vue&type=script&lang=js"
import style0 from "./EditDigiBoardContent.vue?vue&type=style&index=0&id=6603dbd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603dbd0",
  null
  
)

export default component.exports